import type { RouteRecordRaw } from 'vue-router'
import { assertThat } from '../Guards'
import { Role } from '../../Constants/Role.ts'
import { Routes } from '../../Constants/Routes.ts'
import EntityViewPage from '../../Views/EntityViewPage.vue'
import EntitySheet from '../../components/js/Components/Entity/EntitySheet.vue'
import EntityFinancialStatement from '../../components/js/Components/Entity/EntityFinancialStatement.vue'
import EntityDocuments from '../../components/js/Components/Entity/EntityDocuments.vue'
import EntitySimulationList from '../../components/js/Components/Entity/EntitySimulationList.vue'
import EntityDemandList from '../../components/js/Components/Entity/EntityDemandList.vue'
import EntityContractList from '../../components/js/Components/Entity/EntityContractList.vue'
import EntityInvoiceList from '../../components/js/Components/Entity/EntityInvoiceList.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/societes',
    meta: {
      guards: assertThat().authenticated().hasRole(Role.ADMIN_ENTITY),
    },
    children: [
      {
        name: Routes.ENTITY_VIEW,
        path: ':id(\\d+)-:slug(.+)',
        component: EntityViewPage,
        props: (route) => ({ id: Number(route.params.id) }),
        children: [
          {
            name: Routes.ENTITY_VIEW_INFORMATION,
            path: '',
            component: EntitySheet,
            props: (route) => ({ entityId: Number(route.params.id) }),
          },
          {
            name: Routes.ENTITY_VIEW_FINANCIAL_STATEMENTS,
            path: 'bilan',
            component: EntityFinancialStatement,
            props: (route) => ({ entityId: Number(route.params.id) }),
          },
          {
            name: Routes.ENTITY_VIEW_DOCUMENTS,
            path: 'documents',
            component: EntityDocuments,
            props: (route) => ({ entityId: Number(route.params.id) }),
            meta: {
              guards: assertThat().hasRole(Role.ENTITY_DOCUMENTS),
            },
          },
          {
            name: Routes.ENTITY_VIEW_PROPOSALS,
            path: 'proposal',
            component: EntitySimulationList,
            props: (route) => ({ entityId: Number(route.params.id) }),
          },
          {
            name: Routes.ENTITY_VIEW_DEMANDS,
            path: 'demand',
            component: EntityDemandList,
            props: (route) => ({ entityId: Number(route.params.id) }),
          },
          {
            name: Routes.ENTITY_VIEW_CONTRACTS,
            path: 'contract',
            component: EntityContractList,
            props: (route) => ({ entityId: Number(route.params.id) }),
          },
          {
            name: Routes.ENTITY_VIEW_CLIENT_INVOICES,
            path: 'invoice-client',
            component: EntityInvoiceList,
            props: (route) => ({
              entityId: Number(route.params.id),
              filter: 'client',
            }),
            meta: {
              guards: assertThat().hasRole(Role.ENTITY_INVOICES),
            },
          },
          {
            name: Routes.ENTITY_VIEW_SUPPLIER_INVOICES,
            path: 'invoice-supplier',
            component: EntityInvoiceList,
            props: (route) => ({
              entityId: Number(route.params.id),
              filter: 'supplier',
            }),
            meta: {
              guards: assertThat().hasRole(Role.ENTITY_INVOICES),
            },
          },
        ],
      },
    ],
  },
]

export default routes
